var header_nav = {

    defaults: {
        breakpoint: 960,
    },

    settings: {
        header:      null,
        toggle:      null,
        mobileNav:   null,
        panels:      null,
        rootPanel:   null,
        backBtns:    null,
        triggers:    null,
        navItems:    null,
        megaWrap:    null,
    },

    activePanel: null,
    activeMega:  null,

    init: function () {
        header_nav.settings.header      = $('.header-main');
        header_nav.settings.toggle      = $('#nav-toggle');
        header_nav.settings.mobileNav   = $('#main-nav');
        header_nav.settings.panels      = $('.nav-mobile__panel');
        header_nav.settings.rootPanel   = $('.nav-mobile__panel--root');
        header_nav.settings.backBtns    = $('[data-back]');
        header_nav.settings.triggers    = $('.nav-mobile__item');
        header_nav.settings.navItems    = $('.nav-primary li[data-nav]');
        header_nav.settings.megaWrap    = $('.nav-mega');

        header_nav.setHeaderHeight();
        header_nav.bindUIActions();
    },

    bindUIActions: function () {
        // ── Mobile: toggle overlay
        header_nav.settings.toggle.on('click', function () {
            if (header_nav.settings.mobileNav.hasClass('is-open')) {
                header_nav.closeNav();
            } else {
                header_nav.openNav();
            }
        });

        // ── Mobile: push to sub-panel (ignore clicks on the text link, which navigates instead)
        header_nav.settings.triggers.on('click', function (e) {
            if ($(e.target).closest('.nav-mobile__link').length) return;
            var target = $(this).data('target');
            header_nav.pushPanel(target);
        });

        // ── Mobile: pop back to root
        header_nav.settings.backBtns.on('click', function () {
            header_nav.popPanel();
        });

        // ── Desktop: hoverIntent on primary nav items
        header_nav.settings.navItems.hoverIntent(
            function () {
                var id = $(this).data('nav');
                header_nav.openMega(id, $(this));
            },
            function () {
                // leave handled by container mouseleave below
            }
        );

        // ── Desktop: close mega when cursor leaves header area
        header_nav.settings.header.on('mouseleave', function () {
            header_nav.closeMega();
        });

        // ── Desktop: close mega on click outside
        $(document).on('click.nav-mega', function (e) {
            if (!$(e.target).closest('.header-main').length) {
                header_nav.closeMega();
            }
        });

        // ── Escape closes everything
        $(document).on('keydown.nav', function (e) {
            if (e.key === 'Escape') {
                header_nav.closeNav();
                header_nav.closeMega();
            }
        });

        // ── Resize: reset state on crossing desktop breakpoint
        $(window).on('resize.nav', global_helpers.debounce(function () {
            header_nav.setHeaderHeight();

            if ($(window).width() >= header_nav.defaults.breakpoint) {
                header_nav.closeNav();
            } else {
                header_nav.closeMega();
            }
        }, 200));
    },

    // ── Mobile: open overlay
    openNav: function () {
        header_nav.setHeaderBarBottom();
        header_nav.settings.mobileNav.addClass('is-open').attr('aria-hidden', 'false');
        header_nav.settings.toggle.addClass('is-open').attr('aria-expanded', 'true');
        $('body').addClass('nav-is-open');
    },

    // ── Mobile: close overlay and reset all state
    closeNav: function () {
        header_nav.settings.mobileNav.removeClass('is-open').attr('aria-hidden', 'true');
        header_nav.settings.toggle.removeClass('is-open').attr('aria-expanded', 'false');
        $('body').removeClass('nav-is-open');
        header_nav.resetPanels();
    },

    // ── Mobile: push root back and slide target panel in
    pushPanel: function (id) {
        var $target = $('.nav-mobile__panel[data-panel="' + id + '"]');
        if (!$target.length) return;

        header_nav.settings.rootPanel.addClass('is-behind');
        $target.addClass('is-active');
        header_nav.activePanel = id;
    },

    // ── Mobile: slide back to root
    popPanel: function () {
        if (!header_nav.activePanel) return;

        var $panel = $('.nav-mobile__panel[data-panel="' + header_nav.activePanel + '"]');
        $panel.removeClass('is-active');
        header_nav.settings.rootPanel.removeClass('is-behind');
        header_nav.activePanel = null;
    },

    // ── Mobile: reset all panels and accordion state
    resetPanels: function () {
        header_nav.settings.panels.removeClass('is-active is-behind');
        header_nav.settings.rootPanel.removeClass('is-behind');
        header_nav.activePanel = null;
    },

    // ── Mobile: publish where the header bar ends so the overlay sits flush
    //    beneath it, even while the eyebrow banner is still in view above
    setHeaderBarBottom: function () {
        var $bar = header_nav.settings.header.find('.header-bar > .wrapper');
        if (!$bar.length) return;

        var bottom = $bar[0].getBoundingClientRect().bottom;
        document.documentElement.style.setProperty('--header-bar-bottom', bottom + 'px');
    },

    // ── Desktop: publish the header height so mega panels can cap themselves
    //    to the remaining viewport space and scroll instead of getting cut off.
    //    Uses the header's bottom edge so a visible eyebrow banner is included
    setHeaderHeight: function () {
        if (!header_nav.settings.header.length) return;

        var height = header_nav.settings.header[0].getBoundingClientRect().bottom;
        document.documentElement.style.setProperty('--header-height', height + 'px');
    },

    // ── Desktop: open a mega panel
    openMega: function (id, $li) {
        var $panel = $('.nav-mega__panel[data-panel="' + id + '"]');
        if (!$panel.length) return;

        header_nav.setHeaderHeight();

        // Close previously open panel
        if (header_nav.activeMega && header_nav.activeMega !== id) {
            $('.nav-mega__panel[data-panel="' + header_nav.activeMega + '"]').removeClass('is-open');
            header_nav.settings.navItems.filter('.is-open').removeClass('is-open')
                .find('button').attr('aria-expanded', 'false');
        }

        $panel.addClass('is-open').scrollTop(0);
        header_nav.settings.megaWrap.attr('aria-hidden', 'false');

        if ($li) {
            $li.addClass('is-open');
            $li.find('button').attr('aria-expanded', 'true');
        }

        header_nav.activeMega = id;
    },

    // ── Desktop: close all mega panels
    closeMega: function () {
        $('.nav-mega__panel').removeClass('is-open');
        header_nav.settings.megaWrap.attr('aria-hidden', 'true');
        header_nav.settings.navItems.removeClass('is-open')
            .find('button').attr('aria-expanded', 'false');
        header_nav.activeMega = null;
    },

};

header_nav.init();
